// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon-block[data-v-1c54c969] {
  display: flex;
  position: relative;
  width: 48px;
  min-width: 48px;
  height: 48px;
  line-height: 48px;
  font-size: 18px;
  border-radius: 50%;
  text-align: center;
  justify-items: center;
  background-color: var(--icon-bgcolor);
  color: var(--icon-color);
  font-family: Tahoma, sans-serif, Arial, Helvetica;
}
.icon-block .content[data-v-1c54c969] {
  overflow: hidden;
  border-radius: 50%;
  height: 100%;
  width: 100%;
}
.icon-block .alter[data-v-1c54c969] {
  margin: auto;
  -webkit-touch-callout: 'none';
  -webkit-user-select: 'none';
  -khtml-user-select: 'none';
  -moz-user-select: 'none';
  -ms-user-select: 'none';
  user-select: 'none';
}
.icon-block .icon-wrapper[data-v-1c54c969] {
  height: 100%;
  width: 100%;
  display: flex;
}
.icon-block .icon-wrapper img[data-v-1c54c969] {
  height: 100%;
  width: 100%;
  object-fit: cover;
  object-position: center;
  vertical-align: top;
  font-family: "object-fit: cover;";
}
.icon-block .icon-wrapper img[data-v-1c54c969]:before {
  content: ' ';
  display: block;
  height: 100%;
  width: 100%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
.icon-block.small[data-v-1c54c969] {
  width: 26px;
  min-width: 26px;
  height: 26px;
  line-height: 26px;
  font-size: 10px;
}
.icon-block.small-medium[data-v-1c54c969] {
  width: 32px;
  min-width: 32px;
  height: 32px;
  line-height: 32px;
  font-size: 12px;
}
.icon-block.medium[data-v-1c54c969] {
  width: 40px;
  min-width: 40px;
  height: 40px;
  line-height: 40px;
  font-size: 15px;
}
.icon-block.big[data-v-1c54c969] {
  width: 96px;
  min-width: 96px;
  height: 96px;
  line-height: 96px;
  font-size: 36px;
}
.icon-block.medium-big[data-v-1c54c969] {
  width: 110px;
  min-width: 110px;
  height: 110px;
  line-height: 110px;
  font-size: 41px;
}
.icon-block.medium-big .marked[data-v-1c54c969] {
  transform: translate(4.5%) scale(0.91);
}
.icon-block.medium-big .remove[data-v-1c54c969],
.icon-block.medium-big .roll-back[data-v-1c54c969] {
  transform: translate(4.5%, -4.5%) scale(0.637);
}
.icon-block.extra-big[data-v-1c54c969] {
  width: 148px;
  min-width: 148px;
  height: 148px;
  line-height: 148px;
  font-size: 56px;
}
.icon-block.extra-big .marked[data-v-1c54c969] {
  transform: translate(16%) scale(0.68);
}
.icon-block.extra-big .remove[data-v-1c54c969],
.icon-block.extra-big .roll-back[data-v-1c54c969] {
  transform: translate(16%, -16%) scale(0.476);
}
.icon-block.profile-link-icon[data-v-1c54c969] {
  cursor: pointer;
  margin: 5px auto 0 auto;
}
.icon-block.profile-icon[data-v-1c54c969] {
  cursor: pointer;
  margin: 10px auto 10px 10px;
}
.icon-block.noPointerCursor[data-v-1c54c969] {
  cursor: default;
}
.icon-block.rectangular[data-v-1c54c969] {
  margin-top: 5px;
  line-height: 250px;
  width: 100%;
  height: 250px;
  grid-template-rows: 250px;
  border-radius: 5px;
  font-size: 40px;
}
.icon-block.rectangular .content[data-v-1c54c969] {
  border-radius: inherit;
}
.icon-block.editable[data-v-1c54c969] {
  cursor: pointer;
  position: relative;
}
.icon-block.editable .alter[data-v-1c54c969] {
  display: none;
}
.icon-block.editable .icon-wrapper[data-v-1c54c969]:after {
  border-radius: 50%;
  content: "\\f030";
  position: absolute;
  background: var(--icon-wrapper-bgcolor);
  height: 100%;
  width: 100%;
  font-family: "Font Awesome 5 Pro";
  font-weight: lighter;
  -webkit-font-smoothing: antialiased;
}
.icon-block.editable .icon-wrapper[data-v-1c54c969]:hover:after {
  font-weight: bold;
  background: var(--icon-wrapper-bgcolor-hover);
}
.icon-block .marked[data-v-1c54c969],
.icon-block .remove[data-v-1c54c969],
.icon-block .roll-back[data-v-1c54c969] {
  display: flex;
  color: var(--icon-marked-color);
  font-size: 0.5em;
  position: absolute;
  width: 40%;
  height: 40%;
  border: 2px solid var(--icon-border-color);
  border-radius: 50%;
  text-align: center;
}
.icon-block .marked i[data-v-1c54c969],
.icon-block .remove i[data-v-1c54c969],
.icon-block .roll-back i[data-v-1c54c969] {
  margin: 0.5em auto;
}
.icon-block .remove[data-v-1c54c969],
.icon-block .roll-back[data-v-1c54c969] {
  top: 0;
  right: 0;
  background-color: var(--icon-bgcolor);
  color: var(--icon-color);
  cursor: pointer;
}
.icon-block .remove[data-v-1c54c969]:hover,
.icon-block .roll-back[data-v-1c54c969]:hover {
  background-color: var(--icon-btn-bgcolorhover);
}
.icon-block .marked[data-v-1c54c969] {
  right: 0;
  bottom: 0;
  background-color: var(--icon-bgcolor);
}
`, "",{"version":3,"sources":["webpack://./js/app/components/IconImage.vue"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,qCAAqC;EACrC,wBAAwB;EACxB,iDAAiD;AACnD;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;AACA;EACE,YAAY;EACZ,6BAA6B;EAC7B,2BAA2B;EAC3B,0BAA0B;EAC1B,wBAAwB;EACxB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,WAAW;EACX,aAAa;AACf;AACA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;EACnB,iCAAiC;AACnC;AACA;EACE,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,WAAW;EACX,yDAAuG;AACzG;AACA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,sCAAsC;AACxC;AACA;;EAEE,8CAA8C;AAChD;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,qCAAqC;AACvC;AACA;;EAEE,4CAA4C;AAC9C;AACA;EACE,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,2BAA2B;AAC7B;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,uCAAuC;EACvC,YAAY;EACZ,WAAW;EACX,iCAAiC;EACjC,oBAAoB;EACpB,mCAAmC;AACrC;AACA;EACE,iBAAiB;EACjB,6CAA6C;AAC/C;AACA;;;EAGE,aAAa;EACb,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,0CAA0C;EAC1C,kBAAkB;EAClB,kBAAkB;AACpB;AACA;;;EAGE,kBAAkB;AACpB;AACA;;EAEE,MAAM;EACN,QAAQ;EACR,qCAAqC;EACrC,wBAAwB;EACxB,eAAe;AACjB;AACA;;EAEE,8CAA8C;AAChD;AACA;EACE,QAAQ;EACR,SAAS;EACT,qCAAqC;AACvC","sourcesContent":[".icon-block[data-v-1c54c969] {\n  display: flex;\n  position: relative;\n  width: 48px;\n  min-width: 48px;\n  height: 48px;\n  line-height: 48px;\n  font-size: 18px;\n  border-radius: 50%;\n  text-align: center;\n  justify-items: center;\n  background-color: var(--icon-bgcolor);\n  color: var(--icon-color);\n  font-family: Tahoma, sans-serif, Arial, Helvetica;\n}\n.icon-block .content[data-v-1c54c969] {\n  overflow: hidden;\n  border-radius: 50%;\n  height: 100%;\n  width: 100%;\n}\n.icon-block .alter[data-v-1c54c969] {\n  margin: auto;\n  -webkit-touch-callout: 'none';\n  -webkit-user-select: 'none';\n  -khtml-user-select: 'none';\n  -moz-user-select: 'none';\n  -ms-user-select: 'none';\n  user-select: 'none';\n}\n.icon-block .icon-wrapper[data-v-1c54c969] {\n  height: 100%;\n  width: 100%;\n  display: flex;\n}\n.icon-block .icon-wrapper img[data-v-1c54c969] {\n  height: 100%;\n  width: 100%;\n  object-fit: cover;\n  object-position: center;\n  vertical-align: top;\n  font-family: \"object-fit: cover;\";\n}\n.icon-block .icon-wrapper img[data-v-1c54c969]:before {\n  content: ' ';\n  display: block;\n  height: 100%;\n  width: 100%;\n  background-image: url(\"data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7\");\n}\n.icon-block.small[data-v-1c54c969] {\n  width: 26px;\n  min-width: 26px;\n  height: 26px;\n  line-height: 26px;\n  font-size: 10px;\n}\n.icon-block.small-medium[data-v-1c54c969] {\n  width: 32px;\n  min-width: 32px;\n  height: 32px;\n  line-height: 32px;\n  font-size: 12px;\n}\n.icon-block.medium[data-v-1c54c969] {\n  width: 40px;\n  min-width: 40px;\n  height: 40px;\n  line-height: 40px;\n  font-size: 15px;\n}\n.icon-block.big[data-v-1c54c969] {\n  width: 96px;\n  min-width: 96px;\n  height: 96px;\n  line-height: 96px;\n  font-size: 36px;\n}\n.icon-block.medium-big[data-v-1c54c969] {\n  width: 110px;\n  min-width: 110px;\n  height: 110px;\n  line-height: 110px;\n  font-size: 41px;\n}\n.icon-block.medium-big .marked[data-v-1c54c969] {\n  transform: translate(4.5%) scale(0.91);\n}\n.icon-block.medium-big .remove[data-v-1c54c969],\n.icon-block.medium-big .roll-back[data-v-1c54c969] {\n  transform: translate(4.5%, -4.5%) scale(0.637);\n}\n.icon-block.extra-big[data-v-1c54c969] {\n  width: 148px;\n  min-width: 148px;\n  height: 148px;\n  line-height: 148px;\n  font-size: 56px;\n}\n.icon-block.extra-big .marked[data-v-1c54c969] {\n  transform: translate(16%) scale(0.68);\n}\n.icon-block.extra-big .remove[data-v-1c54c969],\n.icon-block.extra-big .roll-back[data-v-1c54c969] {\n  transform: translate(16%, -16%) scale(0.476);\n}\n.icon-block.profile-link-icon[data-v-1c54c969] {\n  cursor: pointer;\n  margin: 5px auto 0 auto;\n}\n.icon-block.profile-icon[data-v-1c54c969] {\n  cursor: pointer;\n  margin: 10px auto 10px 10px;\n}\n.icon-block.noPointerCursor[data-v-1c54c969] {\n  cursor: default;\n}\n.icon-block.rectangular[data-v-1c54c969] {\n  margin-top: 5px;\n  line-height: 250px;\n  width: 100%;\n  height: 250px;\n  grid-template-rows: 250px;\n  border-radius: 5px;\n  font-size: 40px;\n}\n.icon-block.rectangular .content[data-v-1c54c969] {\n  border-radius: inherit;\n}\n.icon-block.editable[data-v-1c54c969] {\n  cursor: pointer;\n  position: relative;\n}\n.icon-block.editable .alter[data-v-1c54c969] {\n  display: none;\n}\n.icon-block.editable .icon-wrapper[data-v-1c54c969]:after {\n  border-radius: 50%;\n  content: \"\\f030\";\n  position: absolute;\n  background: var(--icon-wrapper-bgcolor);\n  height: 100%;\n  width: 100%;\n  font-family: \"Font Awesome 5 Pro\";\n  font-weight: lighter;\n  -webkit-font-smoothing: antialiased;\n}\n.icon-block.editable .icon-wrapper[data-v-1c54c969]:hover:after {\n  font-weight: bold;\n  background: var(--icon-wrapper-bgcolor-hover);\n}\n.icon-block .marked[data-v-1c54c969],\n.icon-block .remove[data-v-1c54c969],\n.icon-block .roll-back[data-v-1c54c969] {\n  display: flex;\n  color: var(--icon-marked-color);\n  font-size: 0.5em;\n  position: absolute;\n  width: 40%;\n  height: 40%;\n  border: 2px solid var(--icon-border-color);\n  border-radius: 50%;\n  text-align: center;\n}\n.icon-block .marked i[data-v-1c54c969],\n.icon-block .remove i[data-v-1c54c969],\n.icon-block .roll-back i[data-v-1c54c969] {\n  margin: 0.5em auto;\n}\n.icon-block .remove[data-v-1c54c969],\n.icon-block .roll-back[data-v-1c54c969] {\n  top: 0;\n  right: 0;\n  background-color: var(--icon-bgcolor);\n  color: var(--icon-color);\n  cursor: pointer;\n}\n.icon-block .remove[data-v-1c54c969]:hover,\n.icon-block .roll-back[data-v-1c54c969]:hover {\n  background-color: var(--icon-btn-bgcolorhover);\n}\n.icon-block .marked[data-v-1c54c969] {\n  right: 0;\n  bottom: 0;\n  background-color: var(--icon-bgcolor);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
